// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__odC7j","box":"WorkspacesBox_box__3Vq92","node":"WorkspacesBox_node__1rVdH"};